module.exports = __webpack_public_path__ + "img/collection1@2x.413c6d9f.png";